import { ParentsTab } from '@features/parents-list/components/ParentsTab'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasPermission } from '@features/rbac/permissions'

export const Route = createFileRoute('/_layout/parents')({
    component: ParentsTab,
    beforeLoad: () => {
        if (!hasPermission('parents.manage')) throw redirect({ to: '/unauthorised' })
    },
    staticData: {
        crumb: {
            label: 'Parents',
        },
    }
})
